import {fsa, fsaError, fsaPayload, fsaPayloadByKeys} from './helpers'

export const ADD_PARTICIPANT = 'adds participant to event'
export const REMOVE_PARTICIPANT = 'removes participant from event'
export const REMOVE_LOOK_PARTICIPANTS = 'removes participants that were assigned to look'

export const UPDATE_CURRENT_PEOPLE = 'update current people'
export const updateCurrentPeople = fsaPayload(UPDATE_CURRENT_PEOPLE)

function shimParticipant(response) {
  return {
    lookId: response.event_look,
    wearers: [
      {
        email: response.participant.email,
        firstName: response.participant.first_name,
        lastName: response.participant.last_name,
        ownerPays: response.event_owner_pays,
        userEventLookId: response.id,
      },
    ],
  }
}

export function addParticipant(response) {
  const newParticipant = shimParticipant(response)
  return {
    type: ADD_PARTICIPANT,
    newParticipant,
  }
}

export function removeParticipant(participantId) {
  return {
    type: REMOVE_PARTICIPANT,
    participantId,
  }
}

export function removeLookParticipants(lookId) {
  return {
    type: REMOVE_LOOK_PARTICIPANTS,
    lookId,
  }
}

export const UPDATE_IS_OWNER_WEARING_LOOK = 'people/update isOwnerWearingLook'
export const updateIsOwnerWearingLook = fsaPayloadByKeys(UPDATE_IS_OWNER_WEARING_LOOK, [
  'lookId',
  'isWearing',
])

export const UPDATE_IS_OWNER_WEARING_LOOK_PENDING = 'people/update isOwnerWearingLook pending'
export const updateIsOwnerWearingLookPending = fsa(UPDATE_IS_OWNER_WEARING_LOOK_PENDING)

export const UPDATE_IS_OWNER_WEARING_LOOK_FAILURE = 'people/update isOwnerWearingLook failure'
export const updateIsOwnerWearingLookFailure = fsaError(UPDATE_IS_OWNER_WEARING_LOOK_FAILURE)

export const UPDATE_IS_OWNER_WEARING_LOOK_SUCCESS = 'people/update isOwnerWearingLook success'
export const updateIsOwnerWearingLookSuccess = fsaPayload(UPDATE_IS_OWNER_WEARING_LOOK_SUCCESS)
